//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GameMode, MAX_MULTIPLIERS ,GameStatus , BetType  } from './enum';

export default {
  name: 'DifficultyGameComponent',
  props: {
    // 当前游戏状态对象
    currentGame: {
      type: Object,
      default: null
    },
    // 当前选择的难度
    selectedMode: {
      type: Number,
      default: GameMode.EASY
    },
    // 主播模式标记
    streamerMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      difficultyButtons: [
        {
          title: '简单',
          value: GameMode.EASY,
          maxMultiplier: '12.00x'
        },
        {
          title: '中等',
          value: GameMode.MEDIUM,
          maxMultiplier: '48.00x'
        },
        {
          title: '困难',
          value: GameMode.HARD,
          maxMultiplier: '256.00x'
        }
      ]
    };
  },
  computed: {
    // 游戏进行中时禁用按钮
    disabled() {
      return this.currentGame && this.currentGame.status === GameStatus.IN_PROGRESS;
    },

    // 当前选中的按钮索引
    selectedIndex() {
      return this.difficultyButtons.findIndex(d => d.value === this.selectedMode);
    },

    // 当前选择难度的最大倍数
    maxMultiplier() {
      return MAX_MULTIPLIERS[this.selectedMode] || 0;
    },

    // 格式化输出两位小数
    formattedMaxMultiplier() {
      return typeof this.maxMultiplier === 'number'
        ? this.maxMultiplier.toFixed(2)
        : '0.00';
    }
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    // 切换难度模式
    setDifficulty(index) {
      if (this.disabled) {
        return;
      }

      const mode = this.difficultyButtons[index];
      if (mode) {
        this.$emit('update:selectedMode', mode.value);
        this.$emit('change-mode', mode.value);
      }
    }
  }
};
